import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getTranslations } from "../../services/common";

export const fetchTranslationsList = createAsyncThunk(
  "translations/fetchTranslations",
  async (payload) => {
    const response = await getTranslations(payload);
    return response.payLoad;
  }
);

const initialState = {
  translations: [],
  status: "idle",
  error: null,
};

export const translationSlice = createSlice({
  name: "translation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTranslationsList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTranslationsList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.translations = action.payload;
      })
      .addCase(fetchTranslationsList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default translationSlice.reducer;
